import { loadCKEditorCloud } from '@ckeditor/ckeditor5-react';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

const {
  CKEditor: { Editor: _Editor },
} = await loadCKEditorCloud({
  version: '44.3.0',
  premium: true,
  translations: ['en'],
});

type Editor = InstanceType<typeof _Editor>;

type EditorContextType = {
  editor: Editor | null;
  setEditor: (editor: Editor | null) => void;
};

export const EditorContext = createContext<EditorContextType | null>(null);

export const EditorProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [editor, setEditor] = useState<Editor | null>(null);

  const value = useMemo(() => ({ editor, setEditor }), [editor, setEditor]);

  return (
    <EditorContext.Provider value={value}>{children}</EditorContext.Provider>
  );
};

export const useEditorContext = () => {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditorContext must be used within an EditorProvider');
  }
  return context;
};

export const useOptionalEditorContext = () => {
  return useContext(EditorContext);
};
